// @mui

import { CSSProperties } from 'react';

// ----------------------------------------------------------------------

function SideBarDocumentsIcon({
  color = '#919EAB',
  style,
}: {
  color?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      width="32"
      height="28"
      viewBox="0 0 32 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M4.33333 22.6667H11C13.7614 22.6667 16 24.9052 16 27.6667V11C16 6.28595 16 3.92893 14.5355 2.46447C13.0711 1 10.714 1 6 1H4.33333C2.76198 1 1.97631 1 1.48816 1.48816C1 1.97631 1 2.76198 1 4.33333V19.3333C1 20.9047 1 21.6904 1.48816 22.1785C1.97631 22.6667 2.76198 22.6667 4.33333 22.6667Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M27.6667 22.6667H21C18.2386 22.6667 16 24.9052 16 27.6667V11C16 6.28595 16 3.92893 17.4645 2.46447C18.9289 1 21.286 1 26 1H27.6667C29.238 1 30.0237 1 30.5118 1.48816C31 1.97631 31 2.76198 31 4.33333V19.3333C31 20.9047 31 21.6904 30.5118 22.1785C30.0237 22.6667 29.238 22.6667 27.6667 22.6667Z"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
}

export default SideBarDocumentsIcon;
